module.exports = __webpack_public_path__ + "static/media/slide-example.622d2d60.gif";